import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/feature/coupons/feature-coupons.service.ts
 * (internal to FeatureService; injected directly as an Angular 18 class).
 */
export { FeatureCouponsService } from '@ng/core/feature/coupons/feature-coupons.service';

export const FeatureCouponsServiceModule = angular.module('acme.common.service.feature.coupons', []).name;
